import { useQuery } from '@tanstack/react-query';
import {
  fetchMonitors,
  fetchAlerts,
  fetchServiceObservability,
  fetchServiceMetrics,
} from '@/api/observability';
import type { MonitorListParams, AlertListParams } from '@/api/observability';

export function useMonitors(params?: MonitorListParams) {
  return useQuery({
    queryKey: ['monitors', params],
    queryFn: () => fetchMonitors(params),
    staleTime: 2 * 60 * 1000,
  });
}

export function useAlerts(params?: AlertListParams) {
  return useQuery({
    queryKey: ['alerts', params],
    queryFn: () => fetchAlerts(params),
    staleTime: 60 * 1000,
  });
}

export function useServiceObservability(serviceSlug: string) {
  return useQuery({
    queryKey: ['service-observability', serviceSlug],
    queryFn: () => fetchServiceObservability(serviceSlug),
    staleTime: 2 * 60 * 1000,
    enabled: !!serviceSlug,
  });
}

export function useServiceMetrics(
  serviceSlug: string,
  metrics?: string,
  periodStart?: string,
  periodEnd?: string,
) {
  return useQuery({
    queryKey: ['service-metrics', serviceSlug, metrics, periodStart, periodEnd],
    queryFn: () => fetchServiceMetrics(serviceSlug, metrics, periodStart, periodEnd),
    staleTime: 2 * 60 * 1000,
    enabled: !!serviceSlug,
  });
}
